function adjustInputForMobile() {
    var billingCpfInput = document.getElementById('shipping_CPF');
    var billingPostcodeInput = document.getElementById('billing_postcode');
    var billingNumberInput = document.getElementById('shipping_number');

    if (window.innerWidth < 999) {
        billingCpfInput.setAttribute('inputmode', 'numeric');
        billingCpfInput.setAttribute('pattern', '\\d*');
        billingPostcodeInput.setAttribute('inputmode', 'numeric');
        billingPostcodeInput.setAttribute('pattern', '\\d*');
        billingNumberInput.setAttribute('inputmode', 'numeric');
        billingNumberInput.setAttribute('pattern', '\\d*');
    } else {
        billingCpfInput.setAttribute('inputmode', 'text');
        billingCpfInput.removeAttribute('pattern');
        billingPostcodeInput.setAttribute('inputmode', 'text');
        billingPostcodeInput.removeAttribute('pattern');
        billingNumberInput.setAttribute('inputmode', 'text');
        billingNumberInput.removeAttribute('pattern');
    }
}

function formatCPF(cpf) {
    cpf = cpf.replace(/\D/g, ""); 
    cpf = cpf.replace(/(\d{3})(\d)/, "$1.$2");
    cpf = cpf.replace(/(\d{3})(\d)/, "$1.$2");
    cpf = cpf.replace(/(\d{3})(\d{1,2})$/, "$1-$2");
    return cpf;
}

document.addEventListener('DOMContentLoaded', function() {
    const billingCpfInput = document.getElementById('shipping_CPF');

    if (!billingCpfInput) {
        return;
    }

    jQuery("#shipping_CPF").mask("999.999.999-99");
    jQuery("#billing_postcode").mask("99999-999");
    jQuery("#shipping_number").mask("0000");

    billingCpfInput.addEventListener('input', function() {
        billingCpfInput.value = formatCPF(billingCpfInput.value);
    });

    adjustInputForMobile();

    window.addEventListener('resize', adjustInputForMobile);
});
